<template>
  <el-card class="h-full flex flex-col" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header :content="title" @back="back"> </el-page-header>
    <el-collapse
      v-model="activeName"
      class="mt-20px overflow-auto border"
      style="height: calc(100% - 52px)"
    >
      <el-collapse-item title="指标信息" name="1">
        <el-form label-width="150px" :model="formData" ref="form" :rules="rules">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="指标名称" prop="name">
                <el-input
                  placeholder="请输入"
                  v-model="formData.name"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标编码" prop="code">
                <el-input
                  placeholder="请输入"
                  v-model="formData.code"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="type === '2'">
              <el-form-item label="指标域" prop="metricsDmainName">
                <el-input
                  placeholder="metricsDmainName"
                  v-model="formData.metricsDmainName"
                  clearable
                  disabled
                  class="!w-full"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间" prop="createdTime">
                <el-input
                  placeholder="请输入"
                  v-model="formData.createdTime"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="计算结果" name="2">
        <el-form label-width="150px" :model="search" ref="searchform">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-form-item label="数据日期">
                <el-date-picker
                  v-model="search.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="!w-full"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="" label-width="0px">
                <el-select
                  placeholder="请选择维度"
                  v-model="search.metricsId"
                  clearable
                  filterable
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in dimensionsList"
                    :key="index"
                    :label="item.asName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="" label-width="0px">
                <el-input
                  placeholder="请输入维度值"
                  v-model="search.value"
                  clearable
                  class="!w-full"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-button type="primary" @click="queryMetricsData()">{{ $t('search') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="tableData" width="100%" height="300" border stripe v-loading="loading">
          <el-table-column
            v-for="(val, index) in tableHeader"
            :prop="val.asCode"
            :label="val.asName"
            :key="index"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-20px"
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="page.pageNo"
          :page-size="page.pageSize"
          :page-sizes="$pageSizeAll"
          layout="->, total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>

<script>
import MetricsManagementService from '@/services/MetricsManagementService'

export default {
  data() {
    return {
      title: '',
      type: '',
      id: '',
      activeName: ['1', '2'],
      formData: {
        name: '',
        code: '',
        createdTime: '',
        metricsDmainName: '',
      },
      rules: {},
      search: {
        date: [],
        metricsId: '',
        value: '',
      },
      tableData: [],
      tableHeader: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dimensionsList: [],
      loading: false,
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 查询指标详情
    async getMetrics() {
      if (!this.id) return
      const res = await MetricsManagementService.getMetrics(this.id)
      if (res && res.code === 0 && res.data) {
        _.assign(this.formData, _.pick(res.data, ['name', 'code', 'createdTime']))
      }
    },
    // 查询指标表头
    async queryMetricsDataHeader() {
      if (!this.id) return
      const res = await MetricsManagementService.queryMetricsDataHeader(this.id)
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
        this.dimensionsList = _.cloneDeep(res.data)
      }
    },
    // 查询指标数据
    async queryMetricsData() {
      if (!this.id) return
      this.loading = true
      const res = await MetricsManagementService.queryMetricsData({
        id: this.id,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        sorting: '',
        startTime: this.search.date.length > 0 ? this.search.date[0] : '',
        endTime: this.search.date.length > 0 ? this.search.date[1] : '',
        metricsDimensionId: this.search.metricsId,
        metricsDimensionValue: this.search.value,
      })
      this.loading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.queryMetricsData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.queryMetricsData()
    },
  },
  created() {
    this.type = this.$route.query.type || ''
    this.id = this.$route.query.id || ''
    this.formData.metricsDmainName = this.$route.query.metricsDmainName || ''
    this.getMetrics()
    this.queryMetricsDataHeader()
    this.queryMetricsData()
    if (this.type === '1') {
      this.title = '派生指标数据'
    } else {
      this.title = '复合指标数据'
    }
  },
}
</script>
